/**
 * サンプル-001
 * 最初の一歩：起動
 */
import { Typescratcher as Ts } from "@tscratch3/typescratcher/index";
// 開始
Ts.engine.start();
//# sourceMappingURL=index.js.map